



export const descargarPdf = (data, nombreArchivo = 'error') => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS) {
        // Lógica específica para iOS
        const reader = new FileReader();
        reader.onload = () => {
            const url = reader.result;
            window.open(url, '_blank');
        };
        reader.readAsDataURL(blob);
    } else {
        // Lógica para otros navegadores
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = nombreArchivo;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
};